import { getSialApiHost } from '../api.js';
import db from '../../versa/db.js';

/**
 * Lista motivos de cancelamento da empresa sem overlay «Carregando…»
 * (#MT-6BF7122 — evita travar a tela ao marcar Status Cancelada).
 * @param {string} companyId
 * @param {boolean} [includeDisabled=false]
 * @returns {Promise<object[]>}
 */
export async function fetchInputCancelReasonsSilent(companyId, includeDisabled = false)
{
	if (!companyId)
		return [];
	try
	{
		const q = includeDisabled ? '?include_disabled=1' : '';
		const res = await fetch(
			`${getSialApiHost()}/companies/${companyId}/input-cancel-reasons${q}`,
			{ method: 'GET', credentials: 'include' },
		);
		if (!res.ok)
			return [];
		const data = await res.json();
		return Array.isArray(data) ? data : [];
	}
	catch (_)
	{
		return [];
	}
}

/**
 * Resolve o id do motivo a partir do valor do campo (id numérico ou nome exato).
 * @param {string|number|null} raw
 * @param {string} companyId
 * @returns {Promise<number|null>}
 */
export async function resolveInputCancelReasonId(raw, companyId)
{
	if (raw == null || String(raw).trim() === '' || !companyId)
		return null;
	const s = String(raw).trim();
	if (/^\d+$/.test(s))
		return Number(s);
	try
	{
		const range = IDBKeyRange.bound([companyId, ''], [companyId, '\uffff']);
		const rows = await db.list('input_cancel_reasons', range, 2);
		const hit = (rows || []).find((r) => String(r.name || '').trim() === s);
		if (hit && hit.id != null)
			return Number(hit.id);
	}
	catch (_) { /* IDB indisponível */ }
	try
	{
		const rows = await fetchInputCancelReasonsSilent(companyId, false);
		if (Array.isArray(rows) && rows.length)
		{
			await db.set('input_cancel_reasons', rows).catch(() => {});
			const hit = rows.find((r) => String(r.name || '').trim() === s && !r.is_disabled);
			if (hit && hit.id != null)
				return Number(hit.id);
		}
	}
	catch (_) { /* rede */ }
	return null;
}

/**
 * Hidrata IndexedDB com motivos da empresa (para datalist no formulário de Entrada).
 * Sem msgbox de loading — a troca de Status não deve travar a tela.
 * @param {string} companyId
 * @param {boolean} [includeDisabled=false] — incluir inativos (ex.: reabrir entrada cancelada)
 * @returns {Promise<object[]>}
 */
export async function hydrateInputCancelReasons(companyId, includeDisabled = false)
{
	if (!companyId)
		return [];
	try
	{
		const rows = await fetchInputCancelReasonsSilent(companyId, includeDisabled);
		if (Array.isArray(rows) && rows.length)
		{
			await db.set('input_cancel_reasons', rows).catch(() => {});
			return includeDisabled ? rows : rows.filter((r) => !r.is_disabled);
		}
	}
	catch (_) { /* ignore */ }
	return [];
}
